import { Badge, Group, Loader, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { TrackingServiceStatus } from '@/types/device'
import { isKnownTrackingStatus, isTrackingBusyStatus } from '../trackingStatus'

const STATUS_CONFIG: Record<
  TrackingServiceStatus,
  { color: string; translationId: string }
> = {
  not_installed: {
    color: 'gray',
    translationId: 'crossCamera.installation.status.notInstalled'
  },
  installing: {
    color: 'blue',
    translationId: 'crossCamera.installation.status.installing'
  },
  running: {
    color: 'green',
    translationId: 'crossCamera.installation.status.running'
  },
  stopped: {
    color: 'gray',
    translationId: 'crossCamera.installation.status.stopped'
  },
  updating: {
    color: 'blue',
    translationId: 'crossCamera.installation.status.updating'
  },
  failed: {
    color: 'red',
    translationId: 'crossCamera.installation.status.failed'
  }
}

type CrossCameraServiceStatusBadgeProps = {
  status: string
}

export const CrossCameraServiceStatusBadge = ({
  status
}: CrossCameraServiceStatusBadgeProps) => {
  if (!isKnownTrackingStatus(status)) {
    return (
      <Text size="sm" c="dimmed">
        {status}
      </Text>
    )
  }

  const config = STATUS_CONFIG[status]

  return (
    <Badge size="sm" color={config.color} tt="none">
      <Group gap={4} wrap="nowrap">
        {isTrackingBusyStatus(status) && <Loader size={10} color="white" />}
        <span>
          <FormattedMessage id={config.translationId} />
        </span>
      </Group>
    </Badge>
  )
}
